import { injectEntityList } from '../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { UIStore } from '../../../../../../common/store/base/UIStore';

import { UserProjectItemView } from './model/UserProjectItemView';

export class ProjectListPageUi extends UIStore {
  constructor(
    public isLoading = injectPrimitive<boolean>(false),
    public isCanEdit = injectPrimitive<boolean>(false),
    public isCanCreate = injectPrimitive<boolean>(false),
    public isCanDelete = injectPrimitive<boolean>(false),
    public isEmpty = injectPrimitive<boolean>(false),
    public userProjects = injectEntityList<UserProjectItemView>([]),
    public searchProjectTerm = injectPrimitive<string>(''),
    public projectListOffset = injectPrimitive<number>(0),
    public projectsTotalCount = injectPrimitive<number>(0),
    public applicationsTotalCount = injectPrimitive<number>(0),
    public isAllProjectsRendered = injectPrimitive<boolean>(false),
    public isLoadingProjects = injectPrimitive<boolean>(true),
    public tableSettings = injectPrimitive<{
      showName: boolean;
      showSystemsCount: boolean;
      showRequirementsCount: boolean;
      showLastActive: boolean;
      showActions: boolean;
    }>({
      showName: true,
      showSystemsCount: true,
      showRequirementsCount: false,
      showLastActive: false,
      showActions: true,
    }),
  ) {
    super();
  }

  startLoading(): void {
    this.isEmpty.setValue(false);
    this.isLoading.setValue(true);
  }

  endLoading(): void {
    this.isLoading.setValue(false);
  }

  setUserProjects(userProjects: UserProjectItemView[]): void {
    this.userProjects.setList(userProjects);
    this.isEmpty.setValue(userProjects.length === 0);
  }
}
